<template>
  <div class="gift-box__change-used-btn">
    <!-- TODO: btn-multi コンポーネントを利用して実装する -->
    <button
      class="btn-multi btn-multi--single"
      @click="clickedButton(ticketId)"
    >
      <span class="btn-multi-arrow-back">
        使えるギフトに戻す
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    ticketId: {
      type: Number,
      require: true,
      // Prop 'ticketId' requires default value to be set  vue/require-default-prop
      // の warning が出るため初期値をセットしている
      default: 0
    }
  },
  methods: {
    clickedButton(ticketId) {
      this.$emit('clicked-revert-button', ticketId)
    }
  }
}
</script>
